import React, { useEffect, useRef, useState } from 'react'
import { embedDashboard } from '@superset-ui/embedded-sdk'
import BlockToolbar from './BlockToolbar'
import Loading from '../../Elements/Loading/LoadingContent'

export default function BlockSuperset(props) {
    const [token, setToken] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const parRef = useRef(null)

    // Fetch guest token from Symfony backend
    useEffect(() => {
        const fetchToken = async () => {
            try {
                setLoading(true)
                const api = props.kedo.api()
                const response = await api.get(
                    `/superset-token?chartLayout=${props.block.settings?.chart_layout}&chartId=${props.block.settings?.chart_identifier}`
                )
                if (!response.data?.token)
                    throw new Error('No token returned from backend')
                console.log('Got guest token:', response.data.token)
                setToken(response.data.token)
            } catch (err) {
                console.error('Error fetching guest token:', err)
                setError(err.message)
            } finally {
                setLoading(false)
            }
        }

        fetchToken()
    }, [props.dashboardId, props.kedo]) // re-run if dashboardId or api changes

    // Embed dashboard when token is ready
    useEffect(() => {
        const mount = async () => {
            if (token && parRef.current) {
                try {
                    await embedDashboard({
                        id: props.block.settings?.chart_identifier,
                        supersetDomain: 'https://superset.kedo.nu',
                        mountPoint: parRef.current,
                        fetchGuestToken: () => token,
                        dashboardUiConfig: {
                            hideTitle: true,
                            hideChartControls: true,
                        },
                    })
                } catch (err) {
                    console.error('Error embedding dashboard:', err)
                    setError('Could not load dashboard')
                }
            }
        }

        mount()
    }, [token, props.dashboardId])

    // Loading / error states
    if (error) {
        return <div style={{ color: 'red' }}>Error: {error}</div>
    }
    if (loading) {
        return <div>Loading Superset dashboard...</div>
    }

    // CSS classes
    let cssClassName = !props.dashboard ? 'kedo-block' : ''
    cssClassName += props.hidePrint ? ' d-print-none' : ' d-print-block'

    return (
        <div
            className=""
            style={{
                width: '100%',
                height: '100vh', // full screen height
                minHeight: '800px', // prevent being too small
                border: '1px solid #ccc',
            }}
        >
            <div
                ref={parRef}
                style={{ minHeight: '800px', width: '100%', height: '100%' }}
            />
        </div>
    )
}
